import useDataRequest from './useDataRequest';
import http from 'utils/request';

/**
 * 产品列表请求 Hook
 * @param {string} type - 产品类型
 */
export const useProductList = (type = '1') => {
  return useDataRequest(
    `productCache_${type}`,
    // 修复: 直接传递查询参数对象,而不是嵌套对象
    () => http.get('/open/device'),
    { useCache: true, immediate: !!type },
  );
};

/**
 * 产品详情请求 Hook
 * @param {string} id - 产品ID
 */
export const useProductDetail = (id) => {
  return useDataRequest(
    `productDetail_${id}`,
    () => http.get(`/open/devicedetail/${id}`),
    { useCache: false, immediate: false },
  );
};

export const useNewProduct = () => {
  return useDataRequest(`newProduct`, () => http.get(`/open/newproduct`), {
    useCache: true,
  });
};
